(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-sldier"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".blog-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1.1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  });

  // Play/pause logic for video
  document.querySelectorAll(".blog-video-container").forEach(container => {
    const video = container.querySelector("video");
    const overlay = container.querySelector(".blog-video-overlay");

    if (video && overlay) {
      const btn = overlay.querySelector(".blog-video-play-btn");

      const togglePlay = () => {
        if (video.paused) {
          video.play();
          overlay.style.display = "none";
        } else {
          video.pause();
          overlay.style.display = "flex";
        }
      };

      overlay.addEventListener("click", togglePlay);
      if (btn) btn.addEventListener("click", e => { e.stopPropagation(); togglePlay(); });

      video.addEventListener("ended", () => {
        video.currentTime = 0;
        video.play();
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protection-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var pdpSwiper = new Swiper(".pdp-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 12,
    pagination: {
      el: ".pdp-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-videoList"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        // 初始化每个 VideoListSwiper（每个都是独立 swiper）
        const swiperWrappers = document.querySelectorAll('.VideoListSwiper-wrapper');
        const swipers = [];

        swiperWrappers.forEach(function(wrapper, idx){
            const container = wrapper.querySelector('.VideoListSwiper');
            // 生成唯一选择器或直接传入 DOM 元素
            const swiper = new Swiper(container, {
            loop: false,
            slidesPerView: "auto",
             breakpoints: {
                0: {
                    spaceBetween: 12, 
                },
                768: {
                    spaceBetween: 12, 
                },
                1000: {
                    spaceBetween: 24, 
                }
               
            },
            
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
            // 根据需要添加更多 Swiper 配置
            });
            swipers.push(swiper); 
        });

        // Tab 切换逻辑（假设 tab 的 data-tab-index 与 swiper wrapper 对齐）
        const tabs = document.querySelectorAll('.SectionVideoList_tabBox');
        tabs.forEach(function(tabEl){
            tabEl.addEventListener('click', function(){
            const index = tabEl.getAttribute('data-tab-index');

            // 切 active 类
            tabs.forEach(t => t.classList.remove('active'));
                tabEl.classList.add('active');

                // 显示对应的 wrapper，隐藏其它
                swiperWrappers.forEach(function(wrapper){
                    if (wrapper.getAttribute('data-tab-index') === index) {
                    wrapper.style.display = ''; // show
                    const i = Number(index);
                    // 有时候需要更新 swiper 的尺寸和状态
                    if (swipers[i] && typeof swipers[i].update === 'function') {
                        swipers[i].update();
                    }
                    } else {
                    wrapper.style.display = 'none';
                    }
                });
            });
        });

        $(".SectionVideoList_Box").on("click", function(){
            var $box = $(this);
            var youtubeUrl = $box.data("url"); // 例如 https://www.youtube.com/watch?v=w6Wlwc0rYtc

            // 提取 ID（支持 watch?v=、youtu.be、各种格式）
            var videoIdMatch = youtubeUrl.match(/(?:v=|youtu\.be\/)([^&]+)/);
            var videoId = videoIdMatch ? videoIdMatch[1] : "";

            // 生成可自动播放的 YouTube embed
            var embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&playsinline=1`;

            var $section = $box.closest(".SectionVideoList_all");
            var $videoFixed = $section.find(".videoList_fixed");
            var $iframe = $videoFixed.find("iframe");

            $iframe.attr("src", embedUrl);

            $videoFixed.fadeIn();
        });



        $(".SectionVideoList_all").on("click", ".videoList_close, .overlay_color", function(e){
            e.stopPropagation();

            var $section = $(this).closest(".SectionVideoList_all");
            var $videoFixed = $section.find(".videoList_fixed");
            var $iframe = $videoFixed.find("iframe");

            // 清空 YouTube 的 src 以停止播放
            $iframe.attr("src", "");

            // 隐藏弹窗
            $videoFixed.fadeOut();
        });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["self-hosted-video-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".custom-video-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1.1, // 👈 mobile
      },
      768: {
        slidesPerView: 2,   // 👈 tablet
      },
      1024: {
        slidesPerView: 3,   // 👈 desktop
      }
    }
  });

  // Handle play/pause only when autoplay is disabled
  document.querySelectorAll(".custom-video-container").forEach(container => {
    const video = container.querySelector("video");
    const overlay = container.querySelector(".custom-video-overlay");

    if (video && overlay) {
      const btn = overlay.querySelector(".custom-video-play-btn");

      const togglePlay = () => {
        if (video.paused) {
          video.play();
          overlay.style.display = "none";
        } else {
          video.pause();
          overlay.style.display = "flex";
        }
      };

      overlay.addEventListener("click", togglePlay);
      if (btn) btn.addEventListener("click", e => { e.stopPropagation(); togglePlay(); });

      video.addEventListener("ended", () => {
        video.currentTime = 0;
        video.play();
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".video-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    loop: false, // no infinite loop
    breakpoints: {
      0: {
        slidesPerView: 1.1, // 👈 mobile: 1.5 slides
      },
      768: {
        slidesPerView: 2,   // 👈 tablet: 2 slides
      },
      1024: {
        slidesPerView: 3,   // 👈 desktop: 3 slides
      }
    },
    on: {
      slideChange: function (swiper) {
        // 👇 your custom function runs here
        console.log("Active slide index:", swiper.activeIndex);

        // Example: add custom class to active slide
        document.querySelectorAll('.video-slider .swiper-slide').forEach(slide => {
          slide.classList.remove('is-active');
        });
        swiper.slides[swiper.activeIndex].classList.add('is-active');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
